import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../lib/components';
import {TimeZoneComponentStore} from '../TimeZoneComponentStore';

@observer
export class AddTimeZoneControls extends React.Component<{ store: TimeZoneComponentStore }> {
  render() {
    const store = this.props.store;

    if (store.addTimeZone === null)
      return null;

    const addTimeZone = store.addTimeZone;
    const isPending = addTimeZone.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Adding time zone" state={addTimeZone.save} align="right"/>
    </>);
  }
}
